import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { Box } from "@mui/material";
import PropTypes from "prop-types";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
  alignLeft: {
    justifyContent: "flex-start",
    "& > *:not(:last-child)": {
      marginRight: theme.spacing(3)
    }
  },
  alignRight: {
    justifyContent: "flex-end",
    "& > *:not(:first-child)": {
      marginLeft: theme.spacing(3)
    }
  }
}));

function ButtonGroup({ children, align, ...styleProps }) {
  const classes = useStyles();
  return (
    <Box
      display="flex"
      className={clsx({
        [classes.alignLeft]: align === "left",
        [classes.alignRight]: align === "right"
      })}
      {...styleProps}
    >
      {children}
    </Box>
  );
}

export default ButtonGroup;

ButtonGroup.propTypes = {
  children: PropTypes.node,
  align: PropTypes.oneOf(["left", "right"])
};

ButtonGroup.defaultProps = {
  align: "right"
};
